"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefined = void 0;
const isDefined = (value) => {
    return value !== null && value !== undefined;
};
exports.isDefined = isDefined;
